/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Carousel,
  DatePicker,
  Image,
  Input,
  Message,
  Modal,
  Popconfirm,
  Select,
  Space,
  Switch,
  Table,
  TableColumnProps,
  Tag,
  Typography
} from '@arco-design/web-react';
import dayjs from 'dayjs';
import { get, post } from '../requestNew';
import './index.scss';

import {
  DEFAULT_RISK_LEVEL,
  formatNoteContent,
  isApproveMap,
  isApproveOption,
  riskLevelOption,
  riskLevelTagMap
} from '../utils';
import { Item } from './types';
const { Option } = Select;
const RangePicker = DatePicker.RangePicker;

const defaultDateRange = (): [string, string] => [
  dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
  dayjs().format('YYYY-MM-DD')
];

function Note() {
  const [commentVisible, setCommentVisible] = useState(false);
  const [commentList, setCommentList] = useState([]);
  const commentId = useRef(0);
  const [notebookInfo, setNotebookInfo] = useState<any>(null);
  const [replyVisible, setReplyVisible] = useState(false);
  const [replyList, setReplyList] = useState<any[]>([]);
  const [gameName, setName] = useState('');
  const [title, setTitle] = useState('');
  const [dateRange, setDateRange] = useState<[string, string]>(defaultDateRange);
  const [pageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<Item[]>([]);
  const [approveStatus, setApprove] = useState('');
  const [isOrder, setIsOrder] = useState<number>(0); // 类型：0-笔记，1-报单，2-全部，默认 0（笔记）
  const [loading, setLoading] = useState(false);
  const [topicId, settopicId] = useState<string>('');
  const [topicList, setTopicList] = useState<Array<{ id: number; topicName: string }>>([]);
  const [orderBy, setOrderBy] = useState<string>('');
  const [hasContent, setHasContent] = useState<number>(1); // 内容：0-全部，1-有内容，2-无内容，默认 1
  const [topType, setTopType] = useState<string>('recommend'); // 置顶类型：recommend-推荐，default-广场，topic-话题
  const [gameSession, setGameSession] = useState<string>(''); // 赛季
  const [sessionList, setSessionList] = useState<Array<{ label: string; value: string }>>([]);
  const [riskLevel, setRiskLevel] = useState(DEFAULT_RISK_LEVEL);
  const prevSorterRef = useRef<any>(null);
  const isRiskQuery = riskLevel !== DEFAULT_RISK_LEVEL;

  const riskColumns: TableColumnProps[] = [
    {
      title: '风险评分',
      dataIndex: 'riskConfidence',
      width: 100,
      render: text => {
        if (text === null || text === undefined || text === '') {
          return '-';
        }
        const num = Number(text);
        return Number.isNaN(num) ? text : num.toFixed(2);
      }
    },
    {
      title: '风险等级',
      dataIndex: 'riskLevel',
      width: 100,
      render: text => {
        const info = riskLevelTagMap[text];
        if (!info) {
          return '-';
        }
        return (
          <Tag color={info.bg} style={{ color: info.text, border: 'none' }}>
            {info.label}
          </Tag>
        );
      }
    },
    {
      title: '风险描述',
      dataIndex: 'riskDescription',
      width: 200,
      render: text => text || '-'
    }
  ];

  const actionColumn: TableColumnProps = {
    title: '操作',
    dataIndex: 'action',
    width: 150,
    fixed: 'right',
    render: (_, record: Item) => (
      <>
        {isRiskQuery && (
          <Popconfirm
            focusLock
            title="提示"
            content="是否确认解除该笔记风险？"
            onOk={() => confirmRiskNotebook(record)}
          >
            <Button className="btn" type="text">
              风险解除
            </Button>
          </Popconfirm>
        )}
        <Button className="btn" type="text" onClick={() => approve(record)}>
          {isApproveMap[record.isApprove] || '未知'}
        </Button>
        <Button className="btn" type="text" onClick={() => showComment(record)}>
          评论管理
        </Button>
        <Button className="btn" type="text" status="danger" onClick={() => del(record)}>
          删除
        </Button>
      </>
    )
  };

  const columns: TableColumnProps[] = [
    {
      title: '发布人',
      dataIndex: 'gameName',
      fixed: 'left',
      width: 100
    },
    {
      title: '标题',
      dataIndex: 'title',
      fixed: 'left',
      width: 120
    },
    {
      title: '内容',
      dataIndex: 'content',
      fixed: 'left',
      width: 400,
      render: text => (
        <Typography.Paragraph
          style={{ marginBottom: 0 }}
          ellipsis={{
            rows: 3,
            showTooltip: {
              type: 'tooltip',
              props: { style: { maxWidth: 640, maxHeight: 360, overflowY: 'auto', whiteSpace: 'pre-wrap' } }
            }
          }}
        >
          {formatNoteContent(text)}
        </Typography.Paragraph>
      )
    },
    {
      title: '发布时间',
      dataIndex: 'createTime',
      width: 130,
      render: text => dayjs(text).format('YYYY-MM-DD')
    },
    {
      title: '状态',
      dataIndex: 'isShow',
      width: 80,
      render: text => (text == 1 ? '公开' : '私密')
    },
    {
      title: '是否可评论',
      dataIndex: 'isCommentable',
      width: 120,
      render: text => (text === 1 ? '可评论' : '不可评论')
    },
    {
      title: '评论数',
      dataIndex: 'commentNum',
      width: 100
    },
    {
      title: '回复数',
      dataIndex: 'replyNum',
      width: 100,
      render: text => text || '-'
    },
    {
      title: '图片',
      dataIndex: 'picture',
      width: 200,
      render: arr => {
        return (
          <div>
            {arr.map((src: string) => (
              <Image style={{ marginRight: 8 }} key={src} width={50} height={50} src={src} alt="" />
            ))}
          </div>
        );
      }
    },
    {
      title: '类型',
      dataIndex: 'isOrder',
      width: 100,
      render: (text: number) => {
        const typeConfig: Record<number, { label: string; color: string }> = {
          0: { label: '笔记', color: 'blue' },
          1: { label: '报单', color: 'red' },
        };
        const config = typeConfig[text] ?? { label: String(text), color: 'gray' };
        return <Tag color={config.color}>{config.label}</Tag>;
      }
    },
    ...(!isRiskQuery
      ? [
          {
            title: '推荐分',
            dataIndex: 'score',
            width: 100,
            render: (text: number | string) => text || '-',
            sorter: true
          },
          {
            title: '加精',
            dataIndex: 'isSuggest',
            width: 80,
            render: (text: number, record: Item) => (
              <Switch
                checked={(text ?? 0) === 1}
                onChange={() => updateStatus(record, 'isSuggest')}
              />
            )
          },
          {
            title: '置顶',
            dataIndex: 'topStatus',
            width: 220,
            render: (_: unknown, record: Item) => (
              <Space size="small" wrap>
                <Space size="small">
                  <Typography.Text type="secondary" style={{ fontSize: 12 }}>推荐</Typography.Text>
                  <Switch
                    size="small"
                    checked={(record.isRecommendTop ?? 0) === 1}
                    onChange={() => updateTopStatus(record, 'recommend')}
                  />
                </Space>
                <Space size="small">
                  <Typography.Text type="secondary" style={{ fontSize: 12 }}>广场</Typography.Text>
                  <Switch
                    size="small"
                    checked={(record.isTop ?? 0) === 1}
                    onChange={() => updateTopStatus(record, 'default')}
                  />
                </Space>
                <Space size="small">
                  <Typography.Text type="secondary" style={{ fontSize: 12 }}>话题</Typography.Text>
                  <Switch
                    size="small"
                    checked={(record.isTopicTop ?? 0) === 1}
                    onChange={() => updateTopStatus(record, 'topic')}
                  />
                </Space>
              </Space>
            )
          }
        ]
      : []),
    ...(isRiskQuery ? riskColumns : []),
    actionColumn
  ];

  const commentColumns: TableColumnProps[] = [
    {
      title: '评论选手',
      dataIndex: 'gameName',
      width: 100
    },
    {
      title: '评论内容',
      dataIndex: 'content',
      width: 300
    },
    {
      title: '评论时间',
      dataIndex: 'createTime',
      width: 150,
      render: text => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      title: '回复数',
      dataIndex: 'replyNum',
      width: 80,
      render: text => text || 0
    },
    {
      title: '操作',
      dataIndex: 'commentAction',
      width: 150,
      render: (_, record: any) => (
        <>
          <Button
            className="btn"
            type="text"
            disabled={!record.replyList || record.replyList.length === 0}
            onClick={() => showReply(record)}
          >
            回复管理
          </Button>
          <Popconfirm focusLock title="提示" content="是否确认删除?" onOk={() => delComment(record)}>
            <Button className="btn" type="text" status="danger">
              删除
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  // 回复列表弹框列定义
  const replyColumns: TableColumnProps[] = [
    {
      title: '评论人',
      dataIndex: 'gameName',
      width: 100
    },
    {
      title: '被回复',
      dataIndex: 'replyToGameName',
      width: 100,
      render: text => text ? `@${text}` : '--'
    },
    {
      title: '内容',
      dataIndex: 'content',
      width: 300
    },
    {
      title: '时间',
      dataIndex: 'createTime',
      width: 150,
      render: text => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      title: '操作',
      dataIndex: 'replyAction',
      width: 80,
      render: (_, record: any) => (
        <Popconfirm focusLock title="提示" content="是否确认删除?" onOk={() => delReply(record)}>
          <Button className="btn" type="text" status="danger">
            删除
          </Button>
        </Popconfirm>
      )
    }
  ];

  const handleDateRangeChange = (dateString: string[]) => {
    setDateRange([dateString?.[0] || '', dateString?.[1] || '']);
  };

  const handleReset = () => {
    setName('');
    setTitle('');
    const resetDateRange = defaultDateRange();
    setDateRange(resetDateRange);
    setApprove('');
    setIsOrder(0);
    settopicId('');
    setHasContent(1);
    setTopType('recommend');
    setRiskLevel(DEFAULT_RISK_LEVEL);
    const resetGameSession = sessionList.length > 0 ? sessionList[0].value : '';
    setGameSession(resetGameSession);
    setPageNum(1);
    setLoading(true);
    get('/notebook/pageNotebook', {
      gameName: '',
      title: '',
      notebookDateStart: resetDateRange[0],
      notebookDateEnd: resetDateRange[1],
      approve: '',
      isOrder: 0,
      topicId: '',
      hasContent: 1,
      topType: 'recommend',
      gameSession: resetGameSession,
      pageSize,
      pageNum: 1
    })
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total } = data;
          setTotal(total);
          setDataList(list || []);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const showComment = (record: Item) => {
    setCommentVisible(true);
    commentId.current = record.id || 0;
    getNotebookInfo();
    getCommentList();
  };

  const getNotebookInfo = () => {
    get('/notebook/getNotebookInfoById', { id: commentId.current })
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          setNotebookInfo(data);
        } else {
          Message.error(message || '获取笔记信息失败');
        }
      })
      .catch(e => {
        Message.error('获取笔记信息失败!');
        console.log(e);
      });
  };

  const getCommentList = () => {
    get('/comment/getCommentListById', { id: commentId.current })
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          setCommentList(data || []);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  const delComment = (record: Item) => {
    post(`/comment/delete?id=${record.id}`)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          // 更新评论量，减1
          if (notebookInfo && notebookInfo.commentNum !== undefined) {
            setNotebookInfo({
              ...notebookInfo,
              commentNum: Math.max(0, (notebookInfo.commentNum || 0) - 1)
            });
          }
          getCommentList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      });
  };

  const showReply = (record: any) => {
    setReplyList(record.replyList || []);
    setReplyVisible(true);
  };

  const closeReply = () => {
    setReplyVisible(false);
    setReplyList([]);
  };

  const delReply = (record: any) => {
    post(`/comment/delete?id=${record.id}`)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('删除成功！');
          closeReply();
          getCommentList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      });
  };

  const closeComment = () => {
    setCommentVisible(false);
    setCommentList([]);
    setNotebookInfo(null);
  };

  const getList = (obj: Record<string, any> = {}, customOrderBy?: string) => {
    const start = obj.notebookDateStart !== undefined ? obj.notebookDateStart : dateRange[0];
    const end = obj.notebookDateEnd !== undefined ? obj.notebookDateEnd : dateRange[1];
    setLoading(true);
    const pagination = {
      pageSize,
      pageNum,
      ...obj
    };
    const params: any = { gameName, title, approve: approveStatus, isOrder, topicId, hasContent, topType, gameSession, ...pagination };
    delete params.createTime;
    delete params.notebookDate;
    if (start) params.notebookDateStart = start;
    if (end) params.notebookDateEnd = end;
    const finalRiskLevel = params.riskLevel !== undefined ? params.riskLevel : riskLevel;
    if (finalRiskLevel && finalRiskLevel !== DEFAULT_RISK_LEVEL) {
      params.riskLevel = finalRiskLevel;
    } else {
      delete params.riskLevel;
    }
    
    // 添加排序参数
    const finalOrderBy = customOrderBy !== undefined ? customOrderBy : orderBy;
    if (finalOrderBy) {
      params.orderByScore = finalOrderBy;
    }
    
    get('/notebook/pageNotebook', params)
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total } = data;
          setTotal(total);
          setDataList(list || []);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateStatus = (record: Item, type: 'isSuggest') => {
    post('/notebook/topNotebook', { notebookId: record.id, [type]: record[type] === 1 ? 0 : 1 })
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('操作成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      });
  };

  type TopType = 'default' | 'recommend' | 'topic';
  const updateTopStatus = (record: Item, topType: TopType) => {
    const payload: any = { notebookId: record.id, topType };
    if (topType === 'default') {
      payload.isTop = (record.isTop ?? 0) === 1 ? 0 : 1;
    } else if (topType === 'recommend') {
      payload.isTop = (record.isRecommendTop ?? 0) === 1 ? 0 : 1;
    } else {
      payload.isTop = (record.isTopicTop ?? 0) === 1 ? 0 : 1;
    }
    post('/notebook/topNotebook', payload)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('操作成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      });
  };

  const del = (record: Item) => {
    get('/notebook/deleteNotebook', { id: record.id })
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('操作成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      });
  };

  const confirmRiskNotebook = (record: Item) => {
    if (!record.id) {
      Message.error('笔记ID不存在！');
      return;
    }
    post(`/notebook/confirmRiskNotebook?id=${record.id}`)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('操作成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      });
  };

  const approve = (record: Item) => {
    const { id, isApprove } = record;
    get('/notebook/approveNotebook', { id, isApprove: isApprove !== 1 ? 1 : 2 })
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('操作成功！');
          if (dataList.length > 1) {
            getList();
          } else {
            setPageNum(pageNum - 1);
          }
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      });
  };

  // 获取话题列表
  const getTopicList = () => {
    get('/topic/list', { pageNum: 1, pageSize: 100 })
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list } = data || {};
          setTopicList(list || []);
        } else {
          Message.error(message || '获取话题列表失败');
        }
      })
      .catch(e => {
        Message.error('获取话题列表失败!');
        console.log(e);
      });
  };

  // 获取赛季列表（参照比赛报名页）
  const getGameSessionList = () => {
    get('/gameConfig/getGameSessionList')
      .then((res: any) => {
        const { data } = res || {};
        if (data && Array.isArray(data) && data.length > 0) {
          const options = data.map((item: any) => ({
            label: item,
            value: item
          }));
          const sortedOptions = options.sort((a, b) => {
            const aVal = String(a.value);
            const bVal = String(b.value);
            const aNum = /^\d+$/.test(aVal);
            const bNum = /^\d+$/.test(bVal);
            if (aNum && bNum) return parseInt(bVal, 10) - parseInt(aVal, 10);
            if (aNum && !bNum) return -1;
            if (!aNum && bNum) return 1;
            return aVal.localeCompare(bVal);
          });
          setSessionList(sortedOptions);
          setGameSession(sortedOptions[0].value);
          getList({ gameSession: sortedOptions[0].value, pageNum: 1 });
        } else {
          getList();
        }
      })
      .catch(() => {
        Message.error('获取赛季列表失败!');
        getList();
      });
  };

  useEffect(() => {
    getTopicList();
    getGameSessionList();
  }, []);
  const isFirstPageNumEffect = useRef(true);
  useEffect(() => {
    if (isFirstPageNumEffect.current) {
      isFirstPageNumEffect.current = false;
      return;
    }
    getList();
  }, [pageNum]);

  const handleApproveChange = (val: string) => {
    setApprove(val);
    // approveStatus 变更时重置到第一页并触发请求，传入最新的 approve 值
    if (pageNum === 1) {
      getList({ approve: val });
    } else {
      setPageNum(1);
    }
  };

  const handleIsOrderChange = (val: number) => {
    setIsOrder(val);
    // 如果选择报单(1)，清空话题
    if (val === 1) {
      settopicId('');
    }
    const nextTopicId = val === 1 ? '' : topicId;
    if (pageNum === 1) {
      getList({ isOrder: val, topicId: nextTopicId, pageNum: 1 });
    } else {
      setPageNum(1);
      getList({ isOrder: val, topicId: nextTopicId, pageNum: 1 });
    }
  };

  const handleTopicChange = (val: string) => {
    settopicId(val);
    // 如果选择话题，自动切换到笔记类型(0)
    if (val) {
      setIsOrder(0);
    }
    const nextIsOrder = val ? 0 : isOrder;
    if (pageNum === 1) {
      getList({ topicId: val, isOrder: nextIsOrder, pageNum: 1 });
    } else {
      setPageNum(1);
      getList({ topicId: val, isOrder: nextIsOrder, pageNum: 1 });
    }
  };

  // 笔记类型选项
  const isOrderOption = [
    { label: '全部', value: 2 },
    { label: '报单', value: 1 },
    { label: '笔记', value: 0 }
  ];

  // 内容是否为空选项
  const hasContentOption = [
    { label: '全部', value: 0 },
    { label: '非空', value: 1 },
    { label: '空', value: 2 }
  ];

  const topTypeOption = [
    { label: '推荐', value: 'recommend' },
    { label: '广场', value: 'default' },
    { label: '话题', value: 'topic' }
  ];

  const handleHasContentChange = (val: number) => {
    setHasContent(val);
    // 选择无内容(2)时，联动切换到报单类型(1)并清空话题
    if (val === 2) {
      setIsOrder(1);
      settopicId('');
    }
    const nextIsOrder = val === 2 ? 1 : isOrder;
    const nextTopicId = val === 2 ? '' : topicId;
    if (pageNum === 1) {
      getList({ hasContent: val, isOrder: nextIsOrder, topicId: nextTopicId });
    } else {
      setPageNum(1);
      getList({ hasContent: val, isOrder: nextIsOrder, topicId: nextTopicId, pageNum: 1 });
    }
  };

  const handleTopTypeChange = (val: string) => {
    setTopType(val);
    if (pageNum === 1) {
      getList({ topType: val });
    } else {
      setPageNum(1);
      getList({ topType: val, pageNum: 1 });
    }
  };

  const handleGameSessionChange = (val: string | undefined) => {
    const next = val ?? '';
    setGameSession(next);
    if (pageNum === 1) {
      getList({ gameSession: next });
    } else {
      setPageNum(1);
      getList({ gameSession: next, pageNum: 1 });
    }
  };

  const handleRiskLevelChange = (val: string) => {
    const next = val ?? DEFAULT_RISK_LEVEL;
    setRiskLevel(next);
    if (pageNum === 1) {
      getList({ riskLevel: next });
    } else {
      setPageNum(1);
    }
  };

  return (
    <div className="note table-flex">
      <Space style={{ flexWrap: 'wrap' }}>
        <div className="filter-item">
          <Typography.Text>发布人:</Typography.Text>
          <Input value={gameName} onChange={setName} style={{ width: 120 }} allowClear />
        </div>
        <div className="filter-item">
          <Typography.Text>标题:</Typography.Text>
          <Input value={title} onChange={setTitle} style={{ width: 120 }} allowClear />
        </div>
        <div className="filter-item">
          <Typography.Text>时间范围:</Typography.Text>
          <RangePicker
            style={{ width: 260 }}
            allowClear
            placeholder={['开始日期', '结束日期']}
            value={dateRange[0] && dateRange[1] ? dateRange : undefined}
            onChange={handleDateRangeChange}
          />
        </div>
        <div className="filter-item">
          <Typography.Text>赛季:</Typography.Text>
          <Select
            value={gameSession}
            onChange={handleGameSessionChange}
            style={{ width: 120 }}
            placeholder="请选择赛季"
            allowClear
          >
            <Option value="">全部</Option>
            {sessionList.map(item => (
              <Option key={item.value} value={item.value}>
                {item.label}
              </Option>
            ))}
          </Select>
        </div>
        <div className="filter-item">
          <Typography.Text>类型:</Typography.Text>
          <Select
            value={isOrder}
            onChange={handleIsOrderChange}
            style={{ width: 80 }}
            placeholder="请选择类型"
            disabled={!!topicId || hasContent === 2}
          >
            {isOrderOption.map(opt => (
              <Option key={opt.value} value={opt.value}>
                {opt.label}
              </Option>
            ))}
          </Select>
        </div>
        <div className="filter-item">
          <Typography.Text>内容:</Typography.Text>
          <Select
            value={hasContent}
            onChange={handleHasContentChange}
            style={{ width: 80 }}
            placeholder="请选择内容"
          >
            {hasContentOption.map(opt => (
              <Option key={opt.value} value={opt.value}>
                {opt.label}
              </Option>
            ))}
          </Select>
        </div>
        <div className="filter-item">
          <Typography.Text>置顶:</Typography.Text>
          <Select
            value={topType}
            onChange={handleTopTypeChange}
            style={{ width: 80 }}
            placeholder="请选择置顶"
          >
            {topTypeOption.map(opt => (
              <Option key={opt.value} value={opt.value}>
                {opt.label}
              </Option>
            ))}
          </Select>
        </div>
        <div className="filter-item">
          <Typography.Text>话题:</Typography.Text>
          <Select
            value={topicId || undefined}
            onChange={handleTopicChange}
            style={{ width: 150 }}
            allowClear
            placeholder="请选择话题"
            disabled={isOrder === 1}
          >
            {topicList.map(topic => (
              <Option key={topic.id} value={String(topic.id)}>
                {topic.topicName}
              </Option>
            ))}
          </Select>
        </div>
        {/* <div className="filter-item">
          <Typography.Text>状态:</Typography.Text>
          <Select
            value={approveStatus}
            onChange={handleApproveChange}
            style={{ width: 100 }}
            placeholder="请选择状态"
          >
            {isApproveOption.map(opt => (
              <Option key={String(opt.value)} value={opt.value === '' ? '' : String(opt.value)}>
                {opt.label}
              </Option>
            ))}
          </Select>
        </div> */}
        <div className="filter-item">
          <Typography.Text>风险等级</Typography.Text>
          <Select
            value={riskLevel}
            onChange={handleRiskLevelChange}
            style={{ width: 120 }}
          >
            {riskLevelOption.map(opt => (
              <Option key={opt.value} value={opt.value}>
                {opt.label}
              </Option>
            ))}
          </Select>
        </div>
        <Button
          className="filter-item"
          type="primary"
          onClick={() => {
            if (pageNum === 1) {
              getList();
            } else {
              setPageNum(1);
            }
          }}
        >
          查询
        </Button>
        <Button
          className="filter-item"
          type="outline"
          onClick={handleReset}
        >
          重置
        </Button>
      </Space>
      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          className="table-scroll"
          data={dataList}
          loading={loading}
          pagination={{
            sizeCanChange: false,
            pageSize,
            total,
            showTotal: true,
            current: pageNum,
            onChange: num => {
              setPageNum(num);
            }
          }}
          scroll={{ y: '100%', x: '100%' }}
          onChange={(pagination, sorter) => {
            // 处理 sorter 可能是数组的情况
            const sorterInfo = Array.isArray(sorter) ? sorter[0] : sorter;
            // 只有当 sorter 存在且有 direction 时，才认为是排序操作
            const hasSorterDirection = sorterInfo && sorterInfo.direction;
            const prevSorter = prevSorterRef.current;
            const prevHasDirection = prevSorter && prevSorter.direction;
            
            // 只有当排序状态真正变化时才处理
            const sorterChanged = 
              (hasSorterDirection && !prevHasDirection) || // 开始排序
              (!hasSorterDirection && prevHasDirection) || // 取消排序
              (hasSorterDirection && prevHasDirection && (
                prevSorter.field !== sorterInfo.field || 
                prevSorter.direction !== sorterInfo.direction
              )); // 排序变化
            
            // 只有当排序变化时才处理
            if (sorterChanged) {
              prevSorterRef.current = sorterInfo ? { ...sorterInfo } : null;
              // 处理排序变化
              if (sorterInfo && sorterInfo.field === 'score' && sorterInfo.direction) {
                let newOrderBy = '';
                if (sorterInfo.direction === 'ascend') {
                  newOrderBy = 'asc';
                } else if (sorterInfo.direction === 'descend') {
                  newOrderBy = 'desc';
                }
                setOrderBy(newOrderBy);
                getList({ pageNum: 1 }, newOrderBy);
              } else {
                // 取消排序
                setOrderBy('');
                getList({ pageNum: 1 }, '');
              }
            }
          }}
        />
      </div>
      <Modal
        title="评论管理"
        visible={commentVisible}
        style={{ width: 900 }}
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={closeComment}
        onOk={closeComment}
        unmountOnExit
      >
        {notebookInfo && (
          <div style={{
            border: '1px solid #e5e5e5',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '16px',
            background: '#fff'
          }}>
            <div style={{ marginBottom: '12px' }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', marginBottom: '4px' }}>
                  <img
                    src={notebookInfo.profilePic || 'https://fulicupdev.oss-cn-hangzhou.aliyuncs.com/profilePic/defaultProfile.png'}
                    alt="头像"
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      marginRight: '12px',
                      objectFit: 'cover'
                    }}
                  />
                  <Typography.Text style={{ fontSize: '14px', marginRight: '8px', fontWeight: 'bold', lineHeight: '1.5' }}>
                    {notebookInfo.gameName || '未知用户'}
                  </Typography.Text>
                  <Typography.Text type="secondary" style={{ fontSize: '14px', lineHeight: '1.5', color: '#333' }}>
                    {notebookInfo.createTime ? dayjs(notebookInfo.createTime).format('MM-DD HH:mm') : ''}
                  </Typography.Text>
                </div>
                {notebookInfo.title && (
                  <Typography.Text style={{ fontSize: '15px', fontWeight: '500', marginBottom: '8px', marginTop: '12px', display: 'block' }}>
                    {notebookInfo.title}
                  </Typography.Text>
                )}
                {notebookInfo.content && (
                  <Typography.Text style={{ fontSize: '14px', marginBottom: '12px', display: 'block', lineHeight: '1.5', color: '#333' }}>
                    {formatNoteContent(notebookInfo.content)}
                  </Typography.Text>
                )}
                {notebookInfo.picture && Array.isArray(notebookInfo.picture) && notebookInfo.picture.length > 0 && (
                  <div className='picture-container'>
                    {notebookInfo.picture.length === 1 ? (
                      <Image
                        src={notebookInfo.picture[0]}
                        alt="笔记图片"
                        preview={true}
                      />
                    ) : (
                      <Carousel
                        autoPlay={false}
                        indicatorPosition="outer"
                        style={{ width: '100%' }}
                      >
                        {notebookInfo.picture.map((pic: string, index: number) => (
                          <div key={index} style={{ textAlign: 'center', width: '100%' }}>
                            <Image
                              src={pic}
                              alt={`笔记图片${index + 1}`}
                              preview={true}
                            />
                          </div>
                        ))}
                      </Carousel>
                    )}
                  </div>
                )}
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginTop: '8px' }}>
                  <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
                    👍 点赞量{notebookInfo.likeNum || 0}
                  </Typography.Text>
                  <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
                    💬 评论量{notebookInfo.commentNum || 0}
                  </Typography.Text>
                </div>
              </div>
            </div>
          </div>
        )}
        <div style={{ height: notebookInfo ? 'calc(70vh - 200px)' : '70vh' }}>
          <Table
            rowKey="id"
            columns={commentColumns}
            className="table-scroll"
            data={commentList}
            pagination={false}
            scroll={{ y: '100%', x: '100%' }}
          />
        </div>
      </Modal>
      <Modal
        title="回复管理"
        visible={replyVisible}
        style={{ width: 1000 }}
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={closeReply}
        onOk={closeReply}
        unmountOnExit
      >
        <Table
          rowKey="id"
          columns={replyColumns}
          data={replyList}
          pagination={false}
          scroll={{ y: 1000 }}
        />
      </Modal>
    </div>
  );
}

export default Note;
